<template>
  <li class="dep__member-item member">
    <img :src="data.avatarUrl" alt class="member-avatar"  @error="handleImgError"/>
    <div class="member-info dep__member-info">
      <div class="is-flex alter-align">
        <div class="is-flex flex-column self-center">
          <p class="dep__member-name member-name" v-if="data.name">{{data.name}}</p>
          <p class="dep__member-user member-user" v-if="data.name">{{data.user}}</p>
          <p class="member-jobtitle" v-if="data.jobtitle">{{data.jobtitle}}</p>
        </div>
        <div class="switch__container">
          <input :id="`switch-flat-${data._id}`" v-model="check" :value="data._id" class="switch switch--flat" type="checkbox" />
          <label :for="`switch-flat-${data._id}`" @click="checkedBox(`switch-flat-${data._id}`)"></label>
        </div>
      </div>
    </div>
  </li>
</template>
<script>
import defaultImg from '../../public/img/unknown-icon.jpg'

export default {
  props: {
    data: {
      required: true
    },
    actionWindow: {
      default: false
    }
  },
  data() {
    return {
      active: false,
      check:[],
      fallbackImg: defaultImg,
    };
  },
  methods: {
    checkedBox(id){
         const id_usuario = id.split('-')[2]
         let temp = this.$store.state.notification_list

        if(!document.getElementById(id).checked){         
           let object = {
             id_usuario:document.getElementById(id).value,
             notificar:true
           }
           
           let vr_existe = temp.filter((value)=>{
             return value.id_usuario == id_usuario
           })
          if(vr_existe.length == 0){
              temp.push(object)
          }else{
             temp.map((value,index)=>{
                if(value.id_usuario == id_usuario){
                   temp[index] = object
                }
             })
          }
           
          this.$store.commit("UpdateNotificationList",temp)

        }else{
           let object = {
             id_usuario:document.getElementById(id).value,
             notificar:false
           }
           temp.map((value,index)=>{
               if(value.id_usuario == id_usuario){
                  temp[index] = object
               }
           })
           this.$store.commit("UpdateNotificationList",temp)
           
        }
    },
    handleMemberClick() {
      if (this.actionWindow) {
        // this.active = true;
      } else {
        if (this.data.actionIcon == "plus") {
          console.log("Add list event");
        }
        if (this.data.actionIcon == "minus") {
          console.log("Remove list event");
        }
      }
    },
    handleImgError(event) {
      event.target.src = this.fallbackImg;
    }
  },
  mounted(){
    //VERIFICA SE O ID DESTE COMPONENTE ESTA NO ARRAY PARA NOTIFICACOES E DA UM CHECK 
    console.log(this.$store.state.notification_list)
    let temp = this.$store.state.notification_list
    temp.map((value)=>{
      console.log(value.id_usuario, this.data)
       if(value.id_usuario == this.data._id){
          if(value.notificar){
             this.check.push(value.id_usuario)
          }
       }
    })
  }
};
</script>

<style scoped>
.member-avatar{
  /* width: 50px;
  height: 50px;
  border-radius: 50%; */
  object-fit: cover;
}
</style>
